var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.hasPadding ? 'p-3 md:p-6' : 'p-0', 'grid grid-cols-12 gap-3']},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }